import React, { useEffect, useState } from "react";
import { Table, Checkbox, message } from "antd";
import { format } from "date-fns";
import { Link, useNavigate } from "react-router-dom";
import { PlusCircle } from "react-feather";
import {
  useGetEmpAllocatedLeaveQuery,
  useUpdateEmployeeLeave,
} from "AppQuries/leave/employee-leave";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { toast } from "core/Operations/toast";

const EmployeeLeave2 = () => {
  const userData = useSelector(loggedInUser);
  const navigate = useNavigate();
  const {
    data: attendnaceData,
    isLoading,
    isError,
    error,
    refetch: getLeaves,
  } = useGetEmpAllocatedLeaveQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    userId: userData?.userID,
    isAllCompanies: userData?.isAllCompanies,
    selectedCompanyCode: userData?.selectedCompanyCode,
  });

  const { mutate: updateLeave } = useUpdateEmployeeLeave();

  const [tableData, setTableData] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  useEffect(() => {
    if (Array.isArray(attendnaceData?.leaveDetails)) {
      const mappedData = attendnaceData.leaveDetails.map((employee) => {
        const row = {
          key: employee.employeeCode,
          uniqueID: employee.uniqueID,
          employeeCode: employee.employeeCode,
          employeeName: employee.employeeName,
          departmentName: employee.departmentName,
          joinDate:
            employee.joinDate !== "" && employee.joinDate !== null
              ? format(new Date(employee.joinDate), "yyyy-MM-dd")
              : "",
          serviceYear: employee.serviceYear,
        };

        attendnaceData.leaveList.forEach((leaveType) => {
          const sanitizedLeaveType = leaveType.replace(/\s+/g, "_");
          const leave = employee.empAllocatedLeaveList.find(
            (l) => l.leaveName === leaveType,
          );
          row[`${sanitizedLeaveType}_alloted`] = leave
            ? leave.noOfAllotedDays
            : 0;
          row[`${sanitizedLeaveType}_taken`] = leave ? leave.leaveTaken : 0;
          row[`${sanitizedLeaveType}_balance`] = leave
            ? leave.balanceLeaveDays
            : 0;
        });

        return row;
      });

      setTableData(mappedData);
    }
  }, [attendnaceData]);

  const handleSelect = (record, selected) => {
    let newSelection = selected
      ? [...selectedEmployees, record.employeeCode]
      : selectedEmployees.filter((code) => code !== record.employeeCode);

    // setValue("selectedEmployees", newSelection);
    setSelectedEmployees(newSelection);
  };

  const toggleSelectAll = () => {
    let newSelection =
      selectedEmployees.length === tableData.length
        ? []
        : tableData.map((r) => r.employeeCode);

    // setValue("selectedEmployees", newSelection);

    setSelectedEmployees((prev) => {
      return prev.length === tableData.length
        ? []
        : tableData.map((r) => r.employeeCode);
    });
  };

  const headerCheckbox = (
    <Checkbox
      checked={selectedEmployees.length === tableData.length}
      indeterminate={
        selectedEmployees.length > 0 &&
        selectedEmployees.length < tableData.length
      }
      onChange={toggleSelectAll}
    />
  );

  const rowSelection = {
    selectedRowKeys: selectedEmployees,
    type: "checkbox",
    fixed: true,
    onSelect: handleSelect,
    columnTitle: headerCheckbox,
  };

  const generateColumns = () => {
    const baseColumns = [
      {
        title: "Emp Code",
        dataIndex: "uniqueID",
        sorter: (a, b) => a.uniqueID.length - b.uniqueID.length,
      },
      {
        title: "Employee Name",
        dataIndex: "employeeName",
        key: "employeeName",
        fixed: "left",
        width: 200,
        render: (text, record) => (
          <Link
            to={`${all_routes.employee}${all_routes.employee_view}/${record.employeeCode}`}
          >
            {text}
          </Link>
        ),
      },
      {
        title: "Department Name",
        dataIndex: "departmentName",
        key: "departmentName",
        fixed: "left",
        width: 200,
        // filters: tableData.map((d) => ({
        //   text: d.departmentName,
        //   value: d.departmentName,
        // })),
        // onFilter: (value, record) =>
        //   record.departmentName.indexOf(value) === 0,
        filters: Array.from(
          new Set(tableData?.map((d) => d?.departmentName).filter(Boolean)),
        ).map((name) => ({ text: name, value: name })),
        onFilter: (value, record) => record.departmentName?.startsWith(value),
      },
      {
        title: "Join Date",
        dataIndex: "joinDate",
        key: "joinDate",
      },
      {
        title: "Service Year",
        dataIndex: "serviceYear",
        key: "serviceYear",
      },
    ];

    if (Array.isArray(attendnaceData?.leaveList)) {
      const dynamicColumns = attendnaceData.leaveList.flatMap((leaveType) => {
        const sanitizedLeaveType = leaveType.replace(/\s+/g, "_");
        return {
          title: leaveType,
          children: [
            {
              title: "Allotted",
              dataIndex: `${sanitizedLeaveType}_alloted`,
              key: `${sanitizedLeaveType}_alloted`,
              align: "center",
            },
            {
              title: "Taken",
              dataIndex: `${sanitizedLeaveType}_taken`,
              key: `${sanitizedLeaveType}_taken`,
              align: "center",
            },
            {
              title: "Balance",
              dataIndex: `${sanitizedLeaveType}_balance`,
              key: `${sanitizedLeaveType}_balance`,
              align: "center",
            },
          ],
        };
      });

      return [...baseColumns, ...dynamicColumns];
    }

    return baseColumns;
  };

  const carryForwardHandler = () => {
    const selectedEmployee = selectedEmployees?.flatMap((e) => {
      return attendnaceData?.leaveDetails
        ?.filter((l) => l.employeeCode === e)
        .flatMap((emp) =>
          emp?.empAllocatedLeaveList?.map((leave) => ({
            slNo: leave.slNo,
            companyCode: leave.companyCode,
            employeeCode: emp.employeeCode,
            leaveCode: leave.leaveCode,
            leaveYear: leave.leaveYear, //0,
            noOfAllotedDays: leave.noOfAllotedDays,
            noOfLeaveCarryForwardFromLastYear:
              leave.noOfLeaveCarryForwardFromLastYear,
            totalLeaveDays: leave.totalLeaveDays,
            leaveTaken: leave.leaveTaken,
            leaveCarryForwardtoNextYear: leave.balanceLeaveDays,
            amountPaidForLeaveDays: leave.amountPaidForLeaveDays,
            balanceLeaveDays: 0,
            createUser: userData?.userName,
            createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
              new Date(),
              "HH:mm:ss.SSS",
            )}Z`,
            modifyUser: userData?.userName,
            modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
              new Date(),
              "HH:mm:ss.SSS",
            )}Z`,
          })),
        );
    });

    updateLeave(selectedEmployee, {
      onSuccess: (data) => {
        console.error(data);
        if (data.response === true) {
          toast.success(
            data.errorMessage || "Leave Carry forward to next year.",
          );

          // setShowSuccessToast(true);
          setTimeout(() => {
            navigate(0);
          }, 1000);
          // getLeaves();
        } else {
          toast.warning(data.errorMessage || "Something went wrong.");
          // setShowErrorToast(true);
        }
      },
      onError: (error) => {
        toast.warning(error.message || "Something went wrong.");
        // setShowErrorToast(true);
      },
    });
  };
  if (isLoading) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Leave Management</h4>
              <h6>Manage employees leaves</h6>
            </div>
          </div>
          {selectedEmployees.length > 0 && (
            <div className="page-btn">
              <button
                onClick={carryForwardHandler}
                className="btn btn-secondary btn-added"
              >
                <i className="fas fas-reply" />
                Carry Forward
              </button>
            </div>
          )}
          {!userData?.isAllCompanies && (
            <div className="page-btn">
              <Link
                to={`${all_routes.leave}${all_routes.apply_leave}`}
                className="btn btn-added"
              >
                <PlusCircle className="me-2" />
                Apply Leave
              </Link>
            </div>
          )}
        </div>

        <Table
          rowSelection={rowSelection}
          columns={generateColumns()}
          dataSource={tableData}
          bordered
          pagination={true}
          scroll={{ x: "max-content" }}
        />
      </div>
    </div>
  );
};

export default EmployeeLeave2;
